/* Folder operations on the store. Pure functions of `state`, no DOM, so
 * they are unit-tested; the UI only handles asking the user. */

/** Every folder name in use: explicitly created ones plus any on a word. */
export function folderNames(state) {
  return Array.from(new Set(state.folders.concat(state.cards.map((c) => c.folder).filter(Boolean))))
    .sort((a, b) => a.localeCompare(b));
}

/**
 * Rename a folder. If `to` already exists the two are merged.
 * @returns {number} how many words moved
 */
export function renameFolder(state, from, to) {
  to = String(to || "").trim();
  if (!from || !to || from === to) return 0;
  let moved = 0;
  for (const c of state.cards) if (c.folder === from) { c.folder = to; moved++; }
  state.folders = Array.from(new Set(state.folders.map((f) => (f === from ? to : f))));
  if (!state.folders.includes(to)) state.folders.push(to);
  return moved;
}

/**
 * Delete a folder.
 * @param {"keep"|"delete"} mode  keep: words move to Unsorted. delete: words go too.
 * @returns {string[]} ids of any words that were deleted
 */
export function deleteFolder(state, name, mode = "keep") {
  const inside = state.cards.filter((c) => c.folder === name);
  let removed = [];
  if (mode === "delete") {
    removed = inside.map((c) => c.id);
    const ids = new Set(removed);
    state.cards = state.cards.filter((c) => !ids.has(c.id));
  } else {
    for (const c of inside) c.folder = null;
  }
  state.folders = state.folders.filter((f) => f !== name);
  return removed;
}
